import { render, staticRenderFns } from "./DataTableReportePartido.vue?vue&type=template&id=00ea32ae&scoped=true&"
import script from "./DataTableReportePartido.vue?vue&type=script&lang=js&"
export * from "./DataTableReportePartido.vue?vue&type=script&lang=js&"
import style0 from "./DataTableReportePartido.vue?vue&type=style&index=0&id=00ea32ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea32ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCardActions,
  VDataTable,
  VFlex,
  VIcon,
  VPagination,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
  VTooltip,
})
